import { render, staticRenderFns } from "./CurtainControl.vue?vue&type=template&id=3c408e48&scoped=true"
import script from "./CurtainControl.vue?vue&type=script&lang=js"
export * from "./CurtainControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c408e48",
  null
  
)

export default component.exports